import { faCalendarDays } from '@fortawesome/pro-regular-svg-icons';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TextFieldProps } from '@mui/material';
import {
    DesktopDatePicker,
    DesktopDatePickerProps,
    LocalizationProvider
} from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import clsx from 'clsx';
import { Input } from 'components/Form/Input/Input';
import { Moment } from 'moment-timezone';
import React from 'react';

import classes from './DatePicker.module.scss';

interface DatePickerProps
    extends Partial<Pick<DesktopDatePickerProps<Moment, Moment>, 'renderInput'>>,
        Omit<DesktopDatePickerProps<Moment, Moment>, 'renderInput'> {
    label: string;
    required?: boolean;
    inputLabelProps?: TextFieldProps['InputLabelProps'];
}

export const DatePicker: React.FC<DatePickerProps> = ({ label, required = false, ...props }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [isFocused, setIsFocused] = React.useState(false);

    return (
        <LocalizationProvider
            dateAdapter={AdapterMoment}
            dateFormats={{ monthAndYear: 'MMM YYYY' }}
        >
            <DesktopDatePicker
                inputFormat="MM/DD/yyyy"
                open={isOpen}
                className={clsx(classes.root, props.className)}
                onOpen={() => setIsOpen(true)}
                onClose={() => setIsOpen(false)}
                PopperProps={{ className: classes.calendarPopper }}
                renderInput={({ InputProps, ...params }) => (
                    <Input
                        {...params}
                        label={label}
                        required={required}
                        InputProps={{
                            ...InputProps,
                            required: required,
                            endAdornment: <FontAwesomeIcon icon={faCaretDown} />,
                            startAdornment: <FontAwesomeIcon icon={faCalendarDays} />
                        }}
                        InputLabelProps={{
                            shrink: isFocused || isOpen || !!props.value,
                            style: { marginLeft: 30 },
                            ...props.inputLabelProps
                        }}
                        onClick={() => setIsOpen(true)}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                    />
                )}
                {...props}
            />
        </LocalizationProvider>
    );
};
